import { render, staticRenderFns } from "./commodityCenter.vue?vue&type=template&id=a4ad83fa"
import script from "./commodityCenter.vue?vue&type=script&lang=js"
export * from "./commodityCenter.vue?vue&type=script&lang=js"
import style0 from "./commodityCenter.vue?vue&type=style&index=0&id=a4ad83fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports